import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import GlobalFooter from 'components/GlobalFooter';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;

  a {
    color: ${({ theme }) => theme.descriptionColor};
  }
`;

const StyledMessage = styled(StyledContainer)`
  font-size: 2rem;
  margin-top: 25vh;
  height: auto;
  a {
    font-weight: 700;
  }
  p {
    font-size: 1.5rem;
  }
`;

export const Unsupported = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledMessage>
        {t('common.unsupportedConfiguration', 'Your current configuration is not supported.')}
        <p>
          <Trans
            i18nKey="common.unsupportedBrowserMessage"
            defaults="Please use the latest version of <firefox>Firefox</firefox> or <chrome>Chrome</chrome>"
            components={{
              firefox: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  target="_blank"
                  href="https://www.mozilla.org/en-US/firefox/"
                  rel="noopener noreferrer"
                />
              ),
              chrome: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  target="_blank"
                  href="https://www.google.com/chrome/"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        </p>
      </StyledMessage>
      <GlobalFooter />
    </StyledContainer>
  );
};
